import React from "react";
import "./FilterPills.css";

/**
 * Reusable FilterPills component
 * Displays category badges arranged across custom rows (default: 3 on top row, 2 on second row).
 *
 * @param {Array<string>} categories - List of category names
 * @param {string} selectedCategory - Currently active category
 * @param {Function} onSelectCategory - Callback when a category pill is clicked
 * @param {Array<number>} splitConfig - Array specifying count of items per row, e.g. [3, 2]
 * @param {string} className - Optional extra CSS class
 */
const FilterPills = ({
  categories = [],
  selectedCategory,
  onSelectCategory,
  splitConfig = [3, 2],
  className = "",
}) => {
  // Split categories into rows based on splitConfig
  const rows = [];
  if (typeof splitConfig === "number" && splitConfig > 0) {
    for (let i = 0; i < categories.length; i += splitConfig) {
      rows.push(categories.slice(i, i + splitConfig));
    }
  } else if (splitConfig && Array.isArray(splitConfig) && splitConfig.length > 0) {
    let index = 0;
    for (const count of splitConfig) {
      if (index >= categories.length) break;
      rows.push(categories.slice(index, index + count));
      index += count;
    }
    // Any remaining categories beyond splitConfig go into the final row
    if (index < categories.length) {
      rows.push(categories.slice(index));
    }
  } else {
    rows.push(categories);
  }

  return (
    <div className={`filter-pills-container ${className}`}>
      {rows.map((rowCategories, rowIndex) => (
        <div className="filter-pills-row" key={rowIndex}>
          {rowCategories.map((category) => {
            const isActive = selectedCategory === category;
            return (
              <button
                key={category}
                type="button"
                className={`filter-pill-btn ${isActive ? "active" : ""}`}
                onClick={() => onSelectCategory(category)}
                aria-pressed={isActive}
              >
                <span className="filter-pill-text">{category}</span>
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default FilterPills;
